module.exports = __webpack_public_path__ + "img/img-kingmaker-d.65d937af.png";